import { NOT_COMPARABLE, type TalentFullTimePreference, type TransitionFitRow } from './transitionScout';

type Props = {
  rows: TransitionFitRow[];
  /** 候補者の希望条件。読み込み中・読み込みに失敗したときは undefined。 */
  preference: TalentFullTimePreference | null | undefined;
  fetching?: boolean;
  error?: string | null;
};

/** 企業の提示と候補者の希望を並べた表。一致・不一致の判定はしない。 */
export const TransitionFitTable = ({ rows, preference, fetching = false, error = null }: Props) => (
  <div className="flex flex-col gap-2">
    <p className="text-sm font-bold text-[#2F3F3F]">候補者の希望条件との比較</p>
    <table className="w-full table-fixed text-sm">
      <thead>
        <tr className="text-left text-xs text-[#596C6C]">
          <th className="w-1/4 pb-1 font-normal">項目</th>
          <th className="pb-1 font-normal">企業の提示</th>
          <th className="pb-1 font-normal">候補者の希望</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label} className="border-t border-[#E4E9E9] align-top">
            <th scope="row" className="py-1 text-left font-medium">
              {row.label}
            </th>
            <td className={row.offer === null ? 'py-1 text-[#809393]' : 'py-1'}>{row.offer ?? NOT_COMPARABLE}</td>
            <td className="py-1">{row.preference}</td>
          </tr>
        ))}
      </tbody>
    </table>
    {fetching && <p className="text-xs text-[#596C6C]">候補者の希望条件を読み込んでいます...</p>}
    {error && <p className="text-negative-dark-default text-xs">{error}</p>}
    {preference === null && (
      <p className="text-xs text-[#596C6C]">候補者の希望条件は確認できません（未登録、または正社員転換の意向がありません）。</p>
    )}
  </div>
);
